<template>
    <section>
        <div v-if="filteredCalls.length" class="or-queue-table-wrapper">
			<b-table
				table-class="or-queue-table"
				:items="filteredCalls"
				:fields="fields"
				:per-page="perPage"
				:current-page="currentPage"
				striped
				hover
				bordered
				outlined
				fixed
				small
				responsive
				sort-by="queue"
				:sort-desc="true"
				@filtered="onFiltered"
            >
				<template #cell(origin)="data">
					<strong>{{ data.item.origin }}</strong>
				</template>
                <template #cell(entry)="data">
                    <span :title="data.item.entry">
                        {{ data.item.entry.length > 27 ? data.item.entry.slice(0, 27) + '...' : data.item.entry }}
                    </span>
                </template>
				<template #cell(wait)="data">
					{{ secondsToTime(data.item.wait) }}
				</template>
            </b-table>
            
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                size="md"
                class="my-0"
            ></b-pagination>
        </div>
        <div v-else>
            <div v-if="!reconnection" class="alert alert-warning">Não há chamadas em fila</div>
            <div v-else class="alert alert-danger">Reconectando ao serviço do Realtime...</div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'OrQueueTable',
        props: [
            'queueList',
            'queueCalls',
            'socketClient',
            'reconnection',
            'enabledListeners'
        ],
        data(){
            return {
                fields: [
					{ key: 'origin', label: 'Telefone', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center fw-bold'},
					{ key: 'queue', label: 'Fila', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center'},
					{ key: 'entry', label: 'Origem', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center'},
					{ key: 'position', label: 'Posição', sortable: false, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center'},
					{ key: 'wait', label: 'Tempo de espera', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center'},
                ],
                perPage: 10,
                currentPage: 1,
                totalRows: 0,
                callTimer: null,
            }
        },
        mounted(){
        },
        computed: {
            filteredCalls(){
                let filtered = this.updatedCalls.sort((a, b) => {
                    if(a.queue === b.queue && a.position < b.position) return -1
                    if(a.queue === b.queue && a.position > b.position) return 1
                    return 0
                });

                return filtered
            },
            updatedCalls(){
                const arr = []
                if(this.queueCalls.length){
                    this.queueCalls.map(el => {
                        if(this.queueList.some(q => q.name === el.queue)){
                          let entry = '---';
                          if(el.entry){
                            const arrEntry = el.entry.split(' ')
                            if(arrEntry.length){
                              entry = arrEntry[0]
                            } 
                          }
                          arr.push({
                              ...el,
                              position: parseInt(el.position, 10),
                              wait: parseInt(el.wait),
                              entry
                          });
                        }
                    })
                }
                return arr
            },
            updatedCallsMap() {
                const map = new Map();
                this.updatedCalls.forEach(call => map.set(call.uniqueid, call));
                return map;
            }
        },
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            async enableListeners(){
				if(!this.socketClient) return
                this.socketClient.removeAllListeners('enteringQueue');
                this.socketClient.removeAllListeners('leavingQueue');

                this.socketClient.on('enteringQueue', async (data) => {
					await this.handleCall(data, 'entering')
                })
                
                this.socketClient.on('leavingQueue', async (data) => {
					await this.handleCall(data, 'leaving')
                })
            },
            async handleCall(data, type){
                const call = this.updatedCallsMap.get(data.uniqueid);
                if(type === 'entering'){
                    if(!call){
                        this.queueCalls.push(data)
                    }
                }

                if(type === 'leaving'){
                    if(call){
                        const index = this.queueCalls.findIndex(q => q.queue === data.queue);
                        if(index !== -1){
                            this.queueCalls.splice(index, 1)

                            // Atualizar posições da fila
                            this.queueCalls.filter(q => q.queue === data.queue)
                                .sort((a, b) => a.position - b.position)
                                .forEach((q, idx) => {
                                    q.position = idx + 1;
                                });
                        }
                    }
                }
            },
            calcCallTimer(){
				clearInterval(this.callTimer);
				this.callTimer = setInterval(() => {
					this.updatedCalls.map((el) => {
						el.wait++
                	})
				}, 1000)
            },
            secondsToTime(seconds) {
				const hours = Math.floor(seconds / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const secs = seconds % 60;

				const pad = (num) => String(num).padStart(2, '0');

				return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
            },
        },
        watch: {
            "enabledListeners.queueCalls": {
				handler(value){
					if(value) this.enableListeners()
				},
            },
            updatedCalls(value){
                this.$emit('callsCount', value.length)
            },
            queueCalls: {
				handler(){
                	this.$nextTick(async () => {
						this.calcCallTimer()
                	});
              	},
            	deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
.or-queue-table-wrapper{
  max-height: 68vh;
  overflow-y: auto;
  margin: 10px;

  ::v-deep(.table-responsive) {
    border-radius: 10px 10px 0 0;
    box-shadow: 1px 1px 3px 1px #0000001f
  }

  ::v-deep(.or-custom-header){
    font-weight: bold;
    text-align: center;
    background-color: #1c869a;
    color: white
  }

  ::v-deep(.small-column){
    width: 100px;
    text-align: center;
  }

  .icon-extension-status {
    align-self: center;
    margin-right: 5px;
  }

  .custom-queue-badge {
    background-color: #287228;
    border-radius: 5px;
    padding: 2px 5px 2px 5px;
    margin: 2px;
    color: white;
  }

  .incall {
    font-size: smaller;
    font-weight: bold;
    background-color: #2a95b1;
    color: white;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 2px 10px 2px 10px;

    .call-info {
      display: flex;
      gap: 10px;
    }

    .call-icons {
      display: flex;
      gap: 5px;
      align-items: center;

      .ringing-icon {
        color: darkblue;
      }
    }
  }

  .available {
    font-size: small;
    font-weight: bold;
    background-color: #aaa;
    border-radius: 10px;
  }

  .paused {
    font-size: small;
    font-weight: bold;
    background-color: #c2b049;
    color: white;
    border-radius: 10px;
  }

  .unpaused {
    font-size: small;
    font-weight: bold;
    background-color: #71a17c;
    color: white;
    border-radius: 10px;
  }

  .cursor-help {
    cursor: help;
  }
  
  .bg-pause {
    background-color: #c2b049;
  }
}

::v-deep(.page-link) {
  font-weight: bold;
  border: none;
  border-radius: 10px !important;
  padding: 5px 10px;
  transition: 0.3s;
  margin: 2px;
  background-color: transparent;
  
  &:hover {
    background-color: #1c859a85;
  }
}

::v-deep(.page-link[aria-checked="true"]) {
  background-color: #1c869a;
}

::v-deep(.page-link[aria-checked="false"]) {
  color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to next page"]) {
  color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to previous page"]) {
  color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to first page"]) {
  color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to last page"]) {
  color: #1c869a;
}
</style>